import { TournamentBrackets } from './tournament-brackets';

function Active() {
  return <TournamentBrackets />;
}

export const route = {
  index: true,
  path: 'active',
  element: <Active />,
};
